var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dropdown-notification", {}, [
    _c("div", { attrs: { slot: "fa-icon" }, slot: "fa-icon" }, [
      _c("i", {
        staticClass: "fa fa-exclamation",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "badge-warning", attrs: { id: "alertas" } }, [
        _vm._v(_vm._s(_vm.notificaciones.length))
      ])
    ]),
    _vm._v(" "),
    _c("div", { attrs: { slot: "content" }, slot: "content" }, [
      _c("div", { staticClass: "notification__name bg-primary" }, [
        _vm._v("Notificaciones")
      ]),
      _vm._v(" "),
      _c(
        "ul",
        [
          _vm._l(_vm.notificaciones, function(notificacion, index) {
            return _c("li", { key: index }, [
              _c(
                "a",
                {
                  attrs: {
                    target: notificacion.url != null ? "_blank" : null,
                    href: notificacion.url != null ? notificacion.url : "#"
                  }
                },
                [_c("span", [_vm._v(_vm._s(notificacion.descripcion))])]
              )
            ])
          }),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.notificaciones.length === 0,
                  expression: "notificaciones.length === 0"
                }
              ]
            },
            [
              _c("a", { attrs: { href: "#" } }, [
                _vm._v("No hay notificaciones disponibles.")
              ])
            ]
          )
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cdca034", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cdca034","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/Notificaciones.vue
// module id = 256
// module chunks = 0